import { Controller } from '@hotwired/stimulus'

import smoothScrollTo from 'utils/smooth-scroll-to'

const SCROLL_DURATION = 500

export default class ScrollToPostcodeController extends Controller {
  static targets = ['link', 'button']

  click() {
    smoothScrollTo('#nu-header', SCROLL_DURATION)
  }
}
